export type SessionBootstrap = {
  fetchProperties: boolean
  loadEmployeeProfile: boolean
  loadHrUser: boolean
}

type SessionBootstrapInput = {
  sessionReady: boolean
  isExpired: boolean
  authUserFail: boolean | null
  platformType: string | null
  userId: string
  hasEmployeeProfile: boolean
  employeeProfileFailed: boolean
}

const idle: SessionBootstrap = {
  fetchProperties: false,
  loadEmployeeProfile: false,
  loadHrUser: false,
}

/**
 * Decide which session calls to make after login.
 *
 * The Okta tile loads /hr/profile/me/ before the employee dashboard mounts, so
 * the HR user id is already set. The employee page still needs
 * /mobile/profile/me/ or it stays on the full-page loader.
 */
export const sessionBootstrap = ({
  sessionReady,
  isExpired,
  authUserFail,
  platformType,
  userId,
  hasEmployeeProfile,
  employeeProfileFailed,
}: SessionBootstrapInput): SessionBootstrap => {
  if (!sessionReady || isExpired || authUserFail) {
    return idle
  }

  const loadEmployeeProfile =
    platformType === 'employee' &&
    !hasEmployeeProfile &&
    !employeeProfileFailed

  if (userId !== '0') {
    return {
      fetchProperties: false,
      loadEmployeeProfile,
      loadHrUser: false,
    }
  }

  return {
    fetchProperties: true,
    loadEmployeeProfile,
    loadHrUser: platformType !== 'employee',
  }
}
